import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeUrlHelper } from '@sc/pas-common';

@Component({
  selector: 'sc-support-pas',
  templateUrl: './support-pas.component.html'
})
export class SupportPasComponent implements OnInit  {


  constructor(
    public urlHelper: HomeUrlHelper,
    public router: Router
  ) { }

  ngOnInit() {
    this.GoToSoportePas()
    this.router.navigate(['inicio']);
  }

  public GoToSoportePas(){
    const url = this.urlHelper.getUrlSoportePas('siniestros');
    window.open(url, '_blank')
  }

}
